import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors, actions } from '../sagas/enforcement';
import MainDrawer from '../InternalNavigation/drawer';
import { Button, Form, FormGroup, FormControl, Row, Col } from 'react-bootstrap';
import { KegImage, Kegmeisters } from '../Keg';
import '../stylesheets/App.css'

class Enforcement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawer: false,
      button: true,
      serialNumber: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  getHistory = () => {
    this.setState({ button: false })
    this.props.getHistory(this.state.serialNumber)
  }

  handleChange(event) {
    let fieldName = event.target.name;
    let fleldVal = event.target.value;
    this.setState({[fieldName]: fleldVal})
  }

  tableLeft = (value) => {
    return(
      <div
        className={'d-inline-block'}> {value} </div>
    )
  }

  render () {
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <Row>
          <Col xs={3}/>
          <Col className={"keg-image-wrapper m-t-10"} xs={6}>
            <KegImage />
          </Col>
          <Col xs={3}/>
        </Row>
        <Row>
          <Col xs={3}/>
          <Col xs={6}>
            <Row>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'}}>
                <Kegmeisters
                  kegClassName={'kegmeisters-keg d-inline-block'}
                  meistersClassName={'kegmeisters-meisters d-inline-block'}
                  wrapperClassName={'d-inline-block m-t-10 kegmeisters-tag'}
                  kegColor={"#FDBF20"}
                  meistersColor={"#303030"}
                  fontSize={58}/>
              </div>
              </Row>
              <Row>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'}}>
                  <Form horizontal >
                    <FormGroup
                      id="km-username"
                      className="form-field"
                      controlId="formHorizontalSerialNumber">
                      <FormControl
                        id="km-login"
                        className="km-login"
                        name="serialNumber"
                        type="Serial Number"
                        onChange={this.handleChange}
                        placeholder="Serial Number" />
                    </FormGroup>
                  </Form>
                </div>
              </Row>
              <Row>
                { this.state.button &&
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'}}>
                  <Button className={'m-t-10'} onClick={this.getHistory}>
                    Submit
                  </Button>
                </div>
                }
              </Row>
          </Col>
          <Col xs={3}/>
        </Row>
        <Row>
          <Col xs={12}>
            { this.props.history &&
              this.props.history.firstName &&
                <div>
                  <table
                    style={{
                      borderRadius: 14,
                      borderStyle: 'solid',
                      borderWidth: 1,
                      width: 100}}>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('First Name') } </td>
                      <td> { this.props.history.firstName } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Last Name') } </td>
                      <td> { this.props.history.lastName } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Street Address') } </td>
                      <td> { this.props.history.streetAddress } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Beer Consumption Address') } </td>
                      <td> { this.props.history.beerConsumptionAddress } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Email') } </td>
                      <td> { this.props.history.email } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Date of Birth') } </td>
                      <td> { this.props.history.birthdate } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Phone') } </td>
                      <td> { this.props.history.phone } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Keg Size') } </td>
                      <td> { this.props.history.kegSize } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Drivers License Number') } </td>
                      <td> { this.props.history.driversLicense } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Return Date') } </td>
                      <td> { this.props.history.returnDate} </td>
                    </tr>
                </table>
              </div>
            }
          </Col>
        </Row>
      </div>
    );
  }

}

const mapStateToProps = (store) => ({
   history: selectors.history(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Enforcement);



// WEBPACK FOOTER //
// ./src/Enforcement/index.js